import { Component, Input } from '@angular/core';
import { FileResponse } from 'src/app/model/file';
import { Ndg } from 'src/app/model/ndg';
import { SurveyNeedsEmit } from 'src/app/model/survey-emits';
import { SurveyResponse } from 'src/app/model/survey-response';
import { FileSaverService } from 'src/app/service/file-saver.service';
import { MessageService } from 'src/app/service/message.service';
import { ReportService } from 'src/app/service/report.service';
import { SpinnerService } from 'src/app/shared/overlay-spinner/service/new-spinner.service';

@Component({
  selector: 'survey-show-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent {
  @Input() survey!: SurveyResponse;
  @Input() ndg!: Ndg;
  @Input() surveyNeeds!: SurveyNeedsEmit

  constructor(
    private reportService: ReportService,
    private spinnerService: SpinnerService,
    private messageService: MessageService,
    private fileSaverService: FileSaverService
  ) {}

  get isSavingsReport(): boolean {
    return this.surveyNeeds.savings || (this.ndg.typology === 'GIU' && this.survey.needsGiu?.premium?.length > 0);
  }

  get isPrevidenceReport(): boolean {
    return this.surveyNeeds.previdence;
  }

  get isProtectionReport(): boolean {
    return this.surveyNeeds.protection || this.ndg.typology === 'GIU';
  }

  doDownloadSaving(target: any) {
    this.spinnerService.showProgress(target);

    this.reportService.getReportSaving(this.survey.surveyId).subscribe({
      next: (fileReponse: FileResponse) => {
        this.fileSaverService.save(fileReponse);
        this.spinnerService.detach(target);
      },
      error: () => {
        this.messageService.error('survey.show.report.download-error');
        this.spinnerService.detach(target);
      }
    });
  }

  doDownloadPrevidence(target: any) {
    this.spinnerService.showProgress(target);

    this.reportService.getReportPrevidence(this.survey.surveyId).subscribe({
      next: (fileReponse: FileResponse) => {
        this.fileSaverService.save(fileReponse);
        this.spinnerService.detach(target);
      },
      error: () => {
        this.messageService.error('survey.show.report.download-error');
        this.spinnerService.detach(target);
      }
    });
  }

  doDownloadProtection(target: any) {
    this.spinnerService.showProgress(target);

    this.reportService.getReportProtection(this.survey.surveyId).subscribe({
      next: (fileReponse: FileResponse) => {
        this.fileSaverService.save(fileReponse);
        this.spinnerService.detach(target);
      },
      error: () => {
        this.messageService.error('survey.show.report.download-error');
        this.spinnerService.detach(target);
      }
    });
  }

  doDownloadQuestionnaire(target: any) {
    this.spinnerService.showProgress(target);

    this.reportService.getReportQuestionnaire(this.survey.surveyId).subscribe({
      next: (fileReponse: FileResponse) => {
        this.fileSaverService.save(fileReponse);
        this.spinnerService.detach(target);
      },
      error: () => {
        this.messageService.error('survey.show.report.download-error');
        this.spinnerService.detach(target);
      }
    });
  }

  get downloading(): boolean {
    return this.spinnerService.isActive();
  }
}
